const ALGOLIA_APP_ID = 'plQGYQFDEYGN';
const ALGOLIA_API_KEY = 'bf915e56c68c23f8e094770704c8913f';

export { ALGOLIA_API_KEY, ALGOLIA_APP_ID };
